/*
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Author: Yaroslav Molodkov
 * Created: December 7, 2023
 *
 */

import {createSelector} from 'reselect';
import {get} from 'lodash';

interface Version {
    value: string;
    label: string;
    current: boolean;
}

const getRawVocabVersions = (state: Object) => get(state, 'vocabulary.versions.queryResult') || [];

const getVocabVersions = createSelector( getRawVocabVersions,
    (rawResults: Array<Version>) => rawResults.map((version: Version) => ({
        value: version.value,
        label: version.current? version.label +"[Current]": version.label,
        current: version.current
    })),
);

export default {
    getVocabVersions,
};

export {Version};
